import ZTable from '@/components/ZTable';
import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { emailColumns, emailFilters, smsColumns, smsFilters } from './utils';

const PAGE_TITLE = 'notificationsPage_title';

export default function GlobalNotificationsPage() {
  const { t } = useTranslation();
  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('notificationsPage_Emails')} key={'emails'}>
            <ZTable
              columns={emailColumns}
              primaryKey="id"
              url="/notifications/email-messages/get-email-messages"
              bordered
              filters={emailFilters}
              order_by="createdOn"
              order_by_asc={false}
              allowEdit={false}
              allowDelete={false}
              searchBtnAlignLeft
            />
          </Tabs.TabPane>

          <Tabs.TabPane tab={t('notificationsPage_Sms')} key={'sms'}>
            <ZTable
              columns={smsColumns}
              primaryKey="id"
              url="/notifications/sms/get-sms-messages"
              bordered
              filters={smsFilters}
              order_by="createdOn"
              order_by_asc={false}
              allowEdit={false}
              allowDelete={false}
              searchBtnAlignLeft
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('notificationsPage_Notifications')} key={'notifications'}>
            <ZTable
              columns={smsColumns}
              primaryKey="id"
              url="/notifications/notifications/get-notifications"
              bordered
              order_by="createdOn"
              order_by_asc={false}
              allowEdit={false}
              allowDelete={false}
              searchBtnAlignLeft
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
